define('modules/includes_editor/index',['require','exports','module','common/models/appstate','./views/main','./views/editor_modal','services/auth','lib/util','common/collections/globals'],function(require, exports, module){
  "use strict";
  var AppState = require("common/models/appstate"),
      IncludesEditorView = require("./views/main"),
      SingleEditorView = require("./views/editor_modal"),
    Auth = require('services/auth'),
    authInfo = Auth.getAuthInfo(),
      util = require("lib/util"),
      GlobalCollection = require("common/collections/globals");

  module.exports = {
    editStyles: function(styles, callback){
      var hasContentChanged = false,
          editorView = new IncludesEditorView({
            collection: styles,
            editorMode: "css"
          });
      AppState.setPropsPopUpOpen(true);

      styles.on("change remove", function() {
        hasContentChanged = true;
      });
      editorView.once("modal:save", function(results){
        callback(results, { silent: !hasContentChanged });
        styles.off("change");
        editorView.hide();
        AppState.setPropsPopUpOpen(false);
      });
    },

    editScripts: function(scripts, callback){
      var self = this,
        globalCollection = new GlobalCollection(null, {
        companyId: authInfo.getCompanyId()
      });

      globalCollection.fetch({
        success: function() {
          self.processScripts(globalCollection, scripts, callback);
        },
        error: function() {
          self.processScripts(globalCollection, scripts, callback);
        }
      });
    },

    processScripts: function (globalCollection, scripts, callback) {
      util.enableField('.js-script-button');
      var hasContentChanged = false,
        editorView = new IncludesEditorView({
          collection: scripts,
          editorMode: "javascript"
        });
      AppState.setPropsPopUpOpen(true);

      scripts.on("remove", function() {
        hasContentChanged = true;
      });

      scripts.on("change", function(script) {
        var contentScript = script.get('content'),
          isGlobalVariable = globalCollection.checkIfContentHasAGlobalVariable(contentScript);

        if (isGlobalVariable) {
          var hasGlobalVariableScriptTags = globalCollection.checkIfGlobalVariableHasTags(contentScript);
          script.set('isTag', hasGlobalVariableScriptTags);
        }

        hasContentChanged = true;
      });

      editorView.once("modal:save", function(results){
        callback(results, { silent: !hasContentChanged });
        scripts.off("change");
        editorView.hide();
        AppState.setPropsPopUpOpen(false);
      });
    },

    editHtml: function(content, callback) {
      var editorView = new SingleEditorView({
        content: content
      });
      AppState.setPropsPopUpOpen(true);

      editorView.once("modal:save", function(results){
        callback(results);
        editorView.hide();
        AppState.setPropsPopUpOpen(false);
      });
    },

    editPopup: function(name, title, content, callback) {
      var editorView = new SingleEditorView({
        name: name,
        title: title,
        content: content
      });
      AppState.setPropsPopUpOpen(true);

      editorView.once("modal:save", function(results) {
        callback(results);
        editorView.hide();
        AppState.setPropsPopUpOpen(false);
      });
    },

    editGlobals: function(globals, callback){
      var editorView = new IncludesEditorView({
        collection: globals,
        editableItemName: true
      });
      AppState.setPropsPopUpOpen(true);
      editorView.once("modal:save", function(results){
        callback(results);
        editorView.hide();
        AppState.setPropsPopUpOpen(false);
      });
    }
  };

});

